import script from "./WomuBackend.vue?vue&type=script&setup=true&name=WomuBackend&lang=js"
export * from "./WomuBackend.vue?vue&type=script&setup=true&name=WomuBackend&lang=js"

import "./WomuBackend.vue?vue&type=style&index=0&id=59f4b9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f4b9b8"]])

export default __exports__